import React, {Component, Fragment} from 'react';
import {Card, CardBody, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import moment from 'moment';
import {i18nizeDate} from '../../../../helpers/Utils';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ReactTable from 'react-table';
import Api from '../../../../services/Api';
import {keyBy, mapValues, omit} from 'lodash';
import {Link} from 'react-router-dom';
import ReactTableTextFilter from '../../../../components/ReactTableTextFilter';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      pages: -1,
      loading: false,
      selectedStartDate: null,
      selectedEndDate: null,
    };
  }

  fetchData = async state => {
    try {
      this.setState({loading: true});
      const offset = state.page * state.pageSize;
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/users-login-history',
        null,
        {
          params: {
            offset,
            limit: state.pageSize,
            ...(state.filtered.length ? omit(mapValues(keyBy(state.filtered, 'id'), 'value'), 'createdAt') : null),
            ...(this.state.selectedStartDate ? {createdFrom: moment(this.state.selectedStartDate).toISOString()} : null),
            ...(this.state.selectedEndDate ? {createdTo: moment(this.state.selectedEndDate).toISOString()} : null),
          },
        },
      );
      this.setState({
        history: data.loginHistory,
        pages: data.totalPage,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  getColumns = t => [
    {
      Header: t('IP'),
      accessor: 'ip',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 180,
    },
    {
      Header: t('User Id'),
      accessor: 'userId',
      filterable: true,
      Filter: ReactTableTextFilter,
      width: 300,
    },
    {
      Header: t('Agent'),
      accessor: 'agent',
    },
    {
      Header: t('Country'),
      accessor: 'country',
      width: 80,
    },
    {
      Header: t('Date'),
      accessor: 'createdAt',
      width: 150,
      Cell: props => <span>{i18nizeDate(props.value)}</span>,
    },
    {
      Header: t('View'),
      width: 60,
      Cell: props => <Link to={{
        pathname: '/dashboard/users/' + props.original.userId,
      }}
      > <i className="simple-icon-eye view-icon"/> </Link>,
    },
  ];

  handleDateChange = (type, date) => {
    this.setState({
      [type]: date,
    });
  };

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <ReactTable
                  manual
                  ref={el => {this.table = el;}}
                  className="-highlight"
                  data={this.state.history}
                  pages={this.state.pages}
                  loading={this.state.loading}
                  sortable={false}
                  resizable={true}
                  onFetchData={this.fetchData}
                  columns={this.getColumns(t)}
                  defaultPageSize={10}
                  style={{
                    width: '100%'
                  }}
                  {...reactTableText}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
